import DatePicker from '@components/_Layout/Controls/DatePicker';
import DateRangePicker from '@components/_Layout/Controls/DateRangePicker';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactDatePickerProps } from 'react-datepicker';

interface SearchDateProps extends ReactDatePickerProps {
  inputType?: "datepicker" | "daterangepicker"
  additionalClassname?: string,
};

const SearchDate: React.FC<SearchDateProps> = ({ inputType = "datepicker", additionalClassname, ...props }) => {

  let result: JSX.Element;
  switch (inputType) {
    case "datepicker":
      result = <>
        <DatePicker additionalClassname={additionalClassname} name="search_dp" {...props} />
      </>
      break;
    case "daterangepicker":
      result = <>
        <DateRangePicker additionalClassname={additionalClassname} name="search_drp" {...props} />
      </>
      break;

    default:
      result = <>
        <DatePicker additionalClassname={additionalClassname} name="search_dp" {...props} />
      </>
      break;
  };

  return (
    result
  )
}

SearchDate.propTypes = {
  inputType: PropTypes.oneOf(["datepicker", "daterangepicker"]),
  additionalClassname: PropTypes.string
};

export default SearchDate;
